import Layout from "components/Layout";
import React from "react";
import ReceiveSettingTable from "./components/ReceiveSettingTable";

function ReceiveSetting() {
  return (
    <Layout title="수신자 관리">
      <ReceiveSettingTable />
    </Layout>
  );
}

export default ReceiveSetting;
